// removed by extract-text-webpack-plugin
module.exports = {"main":"_28StE0G4COSqIGel1nNe81"};


//////////////////
// WEBPACK FOOTER
// ./components/ResetFooter.module.css
// module id = 2371
// module chunks = 1